import React, { Component } from "react";
import ChatList from "./ChatList/index";
import Message from "./Message/index";
import ChatInput from "./ChatInput/index";
import { connect } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserMd } from "@fortawesome/free-solid-svg-icons";
import "./chatScreen.css";
import {
  getChats,
  getListWithContactsData,
  getMessages,
  createImageMessage,
  createMessage,
  activateChat,
  finalizeChat
} from "../../providers/chatProvider";
import {
  updateChatsWithContactData,
  cleanChatNotifications
} from "../../actions";
import { storageKey, uploadImage } from "../../providers/userProvider";

class ChatScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeChat: null,
      message: "",
      userId: null,
      token: null
    };
  }

  componentDidMount() {
    const {
      userInfo,
      chatInit,
      doGetChats,
      doCleanChatNotifications
    } = this.props;
    let { token, _id } = userInfo;
    let userId = _id;

    doCleanChatNotifications();

    if (!token) {
      const info = localStorage.getItem(storageKey);
      if (info) {
        const user = JSON.parse(info);
        token = user.token;
        userId = user._id;
      }
    }

    this.setState({ userId, token });
    if (!chatInit) doGetChats(userId, token);
  }

  uploadPicture = async (e, activeChat) => {
    if (!activeChat) return;
    const picture = e.target.files[0];
    if (!picture) return;

    const { userId, token } = this.state;

    const result = await uploadImage(picture, token);
    if (result.error) {
      return;
    }

    const payload = {
      chatId: activeChat._id,
      userId,
      image: result.url,
      type: "image"
    };

    const response = await createImageMessage(payload, token);

    if (response.error) {
      return;
    }
  };

  renderNoChatSelected() {
    return (
      <div className="no-message-container">
        <FontAwesomeIcon
          icon={faUserMd}
          size="6x"
          color="#888"
          transform={"grow-5"}
        />
        <h3>Selecione um chat</h3>
        <p>
          Selecione uma aba de chat e se consulte novamente com algum de nossos
          médicos
        </p>
      </div>
    );
  }

  handleSelectChat = async chat => {
    return this.setState({
      activeChat: chat
    });
  };

  createMessage = async () => {
    const { activeChat, message, userId, token } = this.state;

    if (!activeChat) return;

    if (
      activeChat.currentConsultId.status === "requested" ||
      activeChat.currentConsultId.status === "finished"
    )
      return;

    if (!message) return;

    const payload = {
      chatId: activeChat._id,
      userId,
      text: message,
      type: "text"
    };

    const result = await createMessage(payload, token);

    if (result.message) {
      return alert(result.message);
    }

    if (result.error) {
      return alert(result.message);
    }

    return this.setState({ message: "" });
  };

  render() {
    const { activeChat, userId, messages, message } = this.state;
    const { chats } = this.props;
    return (
      <div className="chat-container">
        <ChatList
          chats={chats}
          userId={userId}
          active={activeChat}
          onSelectChat={id => this.handleSelectChat(id)}
        />
        <div className="chat-message-container">
          {activeChat === null ? (
            this.renderNoChatSelected()
          ) : (
            <>
              <ul className="messages-container">
                {activeChat.messages.map(message => {
                  let messageInfo = {
                    id: message._id,
                    text: message.text,
                    image: message.image,
                    createdAt: message.createdAt,
                    userId: message.userId,
                    professional: activeChat.professionalId,
                    customer: activeChat.customerId
                  };

                  return (
                    <Message
                      message={messageInfo}
                      key={messageInfo.id}
                      userId={userId}
                    />
                  );
                })}
              </ul>
              <ChatInput
                activeChat={activeChat}
                message={message}
                handleChangeChatMessage={value =>
                  this.setState({ message: value })
                }
                handleSubmit={() => this.createMessage()}
                uploadPicture={(e, activeChat) =>
                  this.uploadPicture(e, activeChat)
                }
              />
            </>
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    doGetChats: (uid, token) => dispatch(getChats(uid, token)),
    subscribeToChatMessages: chatRef => dispatch(getMessages(chatRef)),
    doCleanChatNotifications: () => dispatch(cleanChatNotifications())
  };
};

const mapStateToProps = state => {
  return {
    chats: state.chats.list,
    chatInit: state.chats.init,
    userInfo: state.user.userInfo
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ChatScreen);
